// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__i-y8d","title":"ClientInsurance_title__3H1t-","itemText":"ClientInsurance_itemText__34g_a"};